import { render, staticRenderFns } from "./DiscardEditDialog.vue?vue&type=template&id=6d422850&"
import script from "./DiscardEditDialog.vue?vue&type=script&lang=js&"
export * from "./DiscardEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports